<template>
<div class="mt-5">
  <b-row>
    <b-col sm="6">
      <b-card header="detalhes">
        <dl>
          <dt>Tabela:</dt>
          <dd>{{item.tablename}}</dd>
          <dt>Linhas do ficheiro:</dt>
          <dd>{{item.file_rows}}</dd>
          <dt>Linhas importadas:</dt>
          <dd>{{item.rows_imported}}</dd>
        </dl>
      </b-card>
    </b-col>
    <b-col sm="6">
      <b-card header="erros">
        <div class="errorsReport">{{item.errors}}</div>
      </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: 'ImportDetailView',
  data() {
    return {
      item: {}
    }
  },
  created() {
    var detailId = this.$route.params.detailId
    this.axios.get('import/results/details/' + detailId)
      .then(response => {
        this.item = response.data.data
      })
      .catch(response => {
        this.$toastr('error', 'erro ao carregar resultados da importação', 'Erro')
      })
  }
}
</script>



// WEBPACK FOOTER //
// import_result_view.vue?4a16afa2